import React, { useState } from "react";

const products = [
  {
    name: "Sacred Brass Diya",
    category: "Devotional Decor",
    description:
      "A warm, elegant diya designed for pooja corners, gifting and festive rituals.",
    image: "/images/product-diya.svg",
  },
  {
    name: "Lotus Aura Urli",
    category: "Home & Festive",
    description:
      "A lotus-inspired urli that adds a graceful ceremonial touch to entrances and living spaces.",
    image: "/images/product-urli.svg",
  },
  {
    name: "Divine Gift Hamper",
    category: "Curated Gifting",
    description:
      "A premium spiritual gifting set thoughtfully arranged for celebrations and special occasions.",
    image: "/images/product-hamper.svg",
  },
  {
    name: "Temple Bell Accent",
    category: "Spiritual Lifestyle",
    description:
      "A classic bell accent with timeless styling for meditation rooms and devotional spaces.",
    image: "/images/product-bell.svg",
  },
];

const reviews = [
  {
    quote:
      "The packaging was beautiful and the finish felt genuinely premium. It made our Diwali gifting feel very special.",
    name: "Ritika Sharma",
    role: "Corporate Gifting Client",
  },
  {
    quote:
      "I loved how elegant the pieces looked without feeling overly decorative. They fit perfectly in our modern pooja room.",
    name: "Aman Mehta",
    role: "Home Decor Customer",
  },
  {
    quote:
      "The team was helpful from selection to delivery. The products made wonderful return gifts for our family function.",
    name: "Neha & Kunal",
    role: "Event Gifting Customer",
  },
];

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    e.currentTarget.reset();
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="site-shell">
      <header className="header">
        <div className="container nav-wrap">
          <a
            className="brand"
            href="#home"
            onClick={closeMenu}
            aria-label="Shri Shri Sava Creations home"
          >
            <span className="brand-mark">ॐ</span>
            <span>
              <strong>Shri Shri Sava</strong>
              <small>CREATIONS</small>
            </span>
          </a>

          <button
            className={`menu-toggle ${menuOpen ? "is-open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav
            className={`nav ${menuOpen ? "open" : ""}`}
            aria-label="Primary navigation"
          >
            <a href="#home" onClick={closeMenu}>
              Home
            </a>
            <a href="#about" onClick={closeMenu}>
              About Us
            </a>
            <a href="#products" onClick={closeMenu}>
              Products
            </a>
            <a href="#reviews" onClick={closeMenu}>
              Reviews
            </a>
            <a href="#contact" className="nav-cta" onClick={closeMenu}>
              Contact Us
            </a>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero" id="home">
          <div className="hero-glow glow-one"></div>
          <div className="hero-glow glow-two"></div>
          <div className="container hero-grid">
            <div className="hero-copy">
              <p className="eyebrow">ROOTED IN TRADITION • MADE FOR TODAY</p>
              <h1>
                Creations that bring <span>grace, warmth & meaning</span> to
                every space.
              </h1>
              <p className="hero-text">
                Discover thoughtfully crafted spiritual, festive and lifestyle
                pieces designed for homes, gifting and memorable celebrations.
              </p>
              <div className="hero-actions">
                <a href="#products" className="btn btn-primary">
                  Explore Products
                </a>
                <a href="#contact" className="btn btn-light">
                  Talk to Us
                </a>
              </div>
              <div className="hero-stats">
                <div>
                  <strong>250+</strong>
                  <span>Happy Customers</span>
                </div>
                <div>
                  <strong>40+</strong>
                  <span>Curated Designs</span>
                </div>
                <div>
                  <strong>4.9/5</strong>
                  <span>Customer Love</span>
                </div>
              </div>
            </div>

            <div className="hero-visual">
              <div className="hero-image-card">
                <img
                  src="/images/hero-spiritual.svg"
                  alt="Elegant spiritual decor arrangement"
                />
                <div className="floating-note note-top">Handpicked details</div>
                <div className="floating-note note-bottom">
                  Made for meaningful moments
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section about" id="about">
          <div className="container about-grid">
            <div className="section-copy">
              <p className="eyebrow">ABOUT US</p>
              <h2>
                Celebrating Indian artistry with a modern, thoughtful touch.
              </h2>
              <p>
                Shri Shri Sava Creations is a lifestyle and gifting brand
                inspired by timeless Indian rituals, spiritual aesthetics and
                joyful celebrations. We curate products that feel meaningful
                enough for traditions and refined enough for contemporary homes.
              </p>
              <p>
                From devotional accents to festive gifting, every collection is
                selected with attention to finish, presentation and the emotion
                behind the occasion.
              </p>
              <a href="#contact" className="text-link">
                Know more about custom orders →
              </a>
            </div>

            <div className="about-card-grid">
              <article className="info-card">
                <span className="icon-badge">✦</span>
                <h3>Thoughtful Curation</h3>
                <p>
                  Products selected for elegance, usability and cultural
                  relevance.
                </p>
              </article>
              <article className="info-card">
                <span className="icon-badge">⌁</span>
                <h3>Premium Presentation</h3>
                <p>
                  Beautifully finished pieces suitable for gifting and special
                  occasions.
                </p>
              </article>
              <article className="info-card">
                <span className="icon-badge">❋</span>
                <h3>Personal Touch</h3>
                <p>
                  Flexible support for bulk gifting, family events and curated
                  requirements.
                </p>
              </article>
              <article className="info-card accent-card">
                <p className="accent-kicker">OUR PROMISE</p>
                <h3>Tradition, beautifully reimagined.</h3>
              </article>
            </div>
          </div>
        </section>

        <section className="section products" id="products">
          <div className="container">
            <div className="section-heading centered">
              <p className="eyebrow">OUR PRODUCTS</p>
              <h2>Made for pooja spaces, gifting and celebrations.</h2>
              <p>
                Explore a sample of our curated collection. Product details
                below are demo content and can be replaced easily.
              </p>
            </div>

            <div className="product-grid">
              {products.map((product) => (
                <article className="product-card" key={product.name}>
                  <div className="product-image-wrap">
                    <img src={product.image} alt={product.name} />
                    <span className="product-tag">{product.category}</span>
                  </div>
                  <div className="product-content">
                    <h3>{product.name}</h3>
                    <p>{product.description}</p>
                    <a href="#contact">
                      Enquire now <span>→</span>
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section reviews" id="reviews">
          <div className="container">
            <div className="section-heading centered light-heading">
              <p className="eyebrow">CLIENT REVIEWS</p>
              <h2>Warm words from wonderful customers.</h2>
              <p>Demo testimonials created for the sample website.</p>
            </div>

            <div className="review-grid">
              {reviews.map((review) => (
                <article className="review-card" key={review.name}>
                  <div className="stars" aria-label="5 star review">
                    ★★★★★
                  </div>
                  <p className="review-quote">“{review.quote}”</p>
                  <div className="review-author">
                    <div className="avatar">{review.name.charAt(0)}</div>
                    <div>
                      <strong>{review.name}</strong>
                      <span>{review.role}</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section contact" id="contact">
          <div className="container contact-grid">
            <div className="contact-info">
              <p className="eyebrow">CONTACT US</p>
              <h2>Let’s create something meaningful for your next occasion.</h2>
              <p>
                Reach out for product enquiries, festive orders, custom gifting
                or bulk requirements.
              </p>

              <div className="contact-list">
                <div className="contact-item">
                  <span>✉</span>
                  <div>
                    <small>Email</small>
                    <a href="mailto:admin@shrishrisavacreations.online">
                      admin@shrishrisavacreations.online
                    </a>
                  </div>
                </div>
                <div className="contact-item">
                  <span>☎</span>
                  <div>
                    <small>Phone</small>
                    <a href="tel:+971507805965">+971507805965</a>
                  </div>
                </div>
                <div className="contact-item">
                  <span>⌂</span>
                  <div>
                    <small>Business</small>
                    <strong>AaDiNam House LLC</strong>
                  </div>
                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <label>
                  Your Name
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    required
                  />
                </label>
                <label>
                  Phone Number
                  <input
                    type="tel"
                    name="phone"
                    placeholder="+91 XXXXX XXXXX"
                    required
                  />
                </label>
              </div>
              <label>
                Email Address
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  required
                />
              </label>
              <label>
                I’m interested in
                <select name="interest" defaultValue="">
                  <option value="" disabled>
                    Select an option
                  </option>
                  <option>Product enquiry</option>
                  <option>Bulk gifting</option>
                  <option>Festive orders</option>
                  <option>Custom requirement</option>
                </select>
              </label>
              <label>
                Message
                <textarea
                  name="message"
                  rows="5"
                  placeholder="Tell us what you are looking for..."
                  required
                ></textarea>
              </label>
              <button className="btn btn-primary form-button" type="submit">
                Send Enquiry
              </button>
              {submitted && (
                <p className="success-message" role="status">
                  Thank you! Your demo enquiry has been recorded.
                </p>
              )}
            </form>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container footer-grid">
          <div>
            <a className="brand footer-brand" href="#home">
              <span className="brand-mark">ॐ</span>
              <span>
                <strong>Shri Shri Sava</strong>
                <small>CREATIONS</small>
              </span>
            </a>
            <p>
              Thoughtful spiritual, festive and lifestyle creations for
              beautiful everyday moments.
            </p>
          </div>
          <div>
            <h4>Quick Links</h4>
            <a href="#about">About Us</a>
            <a href="#products">Products</a>
            <a href="#reviews">Reviews</a>
            <a href="#contact">Contact Us</a>
          </div>
          <div>
            <h4>Get in touch</h4>
            <a href="mailto:admin@shrishrisavacreations.online">
              admin@shrishrisavacreations.online
            </a>

            <a href="tel:+971507805965">+971507805965</a>
            <span>AaDiNam House LLC</span>
            <span>Sharjah Media City Sharjah UAE</span>
            <span>Mon–Sat • 10:00 AM–7:00 PM</span>
          </div>
        </div>
        <div className="container footer-bottom">
          <span>© 2026 Shri Shri Sava Creations. All rights reserved.</span>
          <a href="#home">Back to top ↑</a>
        </div>
      </footer>
    </div>
  );
}

export default App;
